module.exports = __webpack_public_path__ + "static/media/homem_r1_c2.09ac210a.jpg";